import { request } from '../utils/http';
import { on } from '../utils/events';

// Dashboard: open/close a team slot in one click; the server returns the re-rendered row
export function initTeamSlots() {
    on('click', '.dash-team-slots .dash-slot', async function (e, slot) {
        const slots = slot.closest('.dash-team-slots');
        const row = slots.closest('.dash-party-row');

        slots.classList.add('loading');

        try {
            const response = await request(slots.dataset.url, {method: 'POST', body: new URLSearchParams({role: slot.dataset.role})});
            row.outerHTML = await response.text();
        } catch (err) {
            slots.classList.remove('loading');
        }
    });

    initTip();
}

// x-alert removes the tip on close; remember that, so it stays gone.
// Storage may be unavailable (private mode), then the tip just shows again next time
function initTip() {
    const tip = document.querySelector('.dash-team-tip');
    if (!tip) return;

    const key = 'dismissed:' + tip.dataset.dismissKey;
    try {
        if (localStorage.getItem(key)) tip.remove();
    } catch (e) {}

    tip.addEventListener('click', function (e) {
        if (!e.target.closest('.pf-alert__close')) return;
        try {
            localStorage.setItem(key, '1');
        } catch (err) {}
    });
}
